import { message } from 'antd';

import { call, put, takeEvery, all, fork, select, takeLatest } from 'redux-saga/effects'
import { getMisParkedAPI } from '../../../services/mis-service';
import { FETCH_PARKED, FETCH_PARKED_ERROR, FETCH_PARKED_START, FETCH_PARKED_SUCCESS, SET_PARKED_FILTER,
SET_PARKED_PAGINATION } from '../../actions/mis/parkedAction';

function* fetchParked({ payload }) {
    try {
        yield put({ type: FETCH_PARKED_START })
        const response = yield call(getMisParkedAPI, payload);
        if (response.success) {
            const pagination = {
                currentPage: payload.page,
                pageSize: payload.size,
                totalPages: response.data.totalPages,
                totalItems: response.data.totalItems,
            }
            yield put({ type: FETCH_PARKED_SUCCESS, parked: response.data.misParked });
            yield put({ type: SET_PARKED_PAGINATION, pagination });
            yield put({ type: SET_PARKED_FILTER, payload: { ...payload } });
        } else {
            yield put({ type: FETCH_PARKED_ERROR, error: response.error })
            message.error('Failed to fetch parked visits!');
        }
    } catch (error) {
        yield put({ type: FETCH_PARKED_ERROR, error })
        message.error('Failed to fetch parked visits!');
    }
}

function* misParkedWatcher() {
    yield takeEvery(FETCH_PARKED, fetchParked)
}

export default function* rootSaga() {
    yield all([
        misParkedWatcher(),
    ]);
}